<div class="wrapper">
  <button
    type="button"
    class="button-reset button-wrapper"
    tabindex="0"
    (click)="onAlbumButtonClick()"
    (keydown)="onPhotoKeyDown($event)">
    <orbit-button
      [styleClass]="'addon-button'"
      rounded
      [icon]="imageIcon"
      [testId]="'btn-browse-file'" />
    <p>{{ 'SHARED.FOOTER_ADDON_USER.ALBUM' | translate }}</p>
    <input
      hidden
      data-testid="input-browse-file"
      #photoUploader
      id="photoUploader"
      type="file"
      name="photoUploader"
      accept="image/*,video/*"
      (change)="onFileSelected($event, footerButtonTypeEnum.Album)" />
  </button>
  @if (senderType() === messageSenderTypeEnum.Client) {
    @if (supportsCaptureAttribute()) {
      <button
        type="button"
        class="button-reset button-wrapper"
        tabindex="0"
        (click)="onCameraButtonClick()"
        (keydown)="onCameraKeyDown($event)">
        <orbit-button
          [styleClass]="'addon-button'"
          rounded
          [icon]="cameraIcon"
          [testId]="'btn-camera'" />
        <p>{{ 'SHARED.FOOTER_ADDON_USER.CAMERA' | translate }}</p>
        <input
          hidden
          data-testid="input-camera"
          #cameraUploader
          id="cameraUploader"
          name="cameraUploader"
          type="file"
          accept="image/*"
          capture="camera"
          (change)="onFileSelected($event, footerButtonTypeEnum.Camera)" />
      </button>
    } @else {
      <button
        type="button"
        class="button-reset button-wrapper"
        tabindex="0"
        (click)="onCameraButtonClick()"
        (keydown)="onWebCameraKeyDown($event)">
        <orbit-button
          [styleClass]="'addon-button'"
          rounded
          [icon]="cameraIcon"
          [testId]="'btn-user-camera'" />
        <p>{{ 'SHARED.FOOTER_ADDON_USER.CAMERA' | translate }}</p>
        <input
          hidden
          data-testid="input-user-camera"
          #cameraUploader
          id="cameraUploader"
          name="cameraUploader"
          type="file"
          accept="image/*"
          capture="camera"
          (change)="onFileSelected($event, footerButtonTypeEnum.Camera)" />
      </button>
    }
    <button
      type="button"
      class="button-reset button-wrapper"
      tabindex="0"
      (click)="onVideoButtonClick()"
      (keydown)="onVideoKeyDown($event)">
      <orbit-button
        [styleClass]="'addon-button'"
        rounded
        [icon]="videoIcon"
        [testId]="'btn-video'" />
      <p>{{ 'SHARED.FOOTER_ADDON_USER.VIDEO' | translate }}</p>
      <input
        hidden
        data-testid="input-video"
        #videoUploader
        id="videoUploader"
        name="videoUploader"
        type="file"
        accept="video/*"
        capture="camcorder"
        (change)="onFileSelected($event, footerButtonTypeEnum.Video)" />
    </button>
    @if (!isSafari()) {
      <button
        type="button"
        class="button-reset button-wrapper"
        tabindex="0"
        (click)="onAudioButtonClick()"
        (keydown)="onAudioKeyDown($event)">
        <orbit-button
          [styleClass]="'addon-button'"
          rounded
          [icon]="microphoneIcon"
          [testId]="'btn-audio'" />
        <p>{{ 'SHARED.FOOTER_ADDON_USER.AUDIO' | translate }}</p>
        <input
          hidden
          data-testid="input-audio"
          #audioUploader
          id="audioUploader"
          name="audioUploader"
          type="file"
          accept="audio/*"
          capture="microphone"
          (change)="onFileSelected($event, footerButtonTypeEnum.Audio)" />
      </button>
    }
    <button
      type="button"
      class="button-reset button-wrapper"
      tabindex="0"
      (click)="buttonClick.emit(footerButtonTypeEnum.Location)"
      (keydown)="onLocationKeyDown($event)">
      <orbit-button
        [styleClass]="'addon-button'"
        rounded
        [icon]="locationDotIcon"
        [testId]="'btn-location'" />
      <p>{{ 'SHARED.FOOTER_ADDON_USER.LOCATION' | translate }}</p>
    </button>
  }
  @if (senderType() === messageSenderTypeEnum.TenantUser) {
    <button
      type="button"
      class="button-reset button-wrapper"
      tabindex="0"
      (click)="onCameraButtonClick()"
      (keydown)="onWebCameraKeyDown($event)">
      <orbit-button
        [styleClass]="'addon-button'"
        rounded
        [icon]="cameraIcon"
        [testId]="'btn-user-camera'" />
      <p>{{ 'SHARED.FOOTER_ADDON_USER.CAMERA' | translate }}</p>
      <input
        hidden
        data-testid="input-user-camera"
        #cameraUploader
        id="cameraUploader"
        name="cameraUploader"
        type="file"
        accept="image/*"
        capture="camera"
        (change)="onFileSelected($event, footerButtonTypeEnum.Camera)" />
    </button>
    <button
      type="button"
      class="button-reset button-wrapper"
      tabindex="0"
      (click)="buttonClick.emit(footerButtonTypeEnum.Location)"
      (keydown)="onLocationKeyDown($event)">
      <orbit-button
        [styleClass]="'addon-button'"
        rounded
        [icon]="locationDotIcon"
        [testId]="'btn-user-location'" />
      <p>{{ 'SHARED.FOOTER_ADDON_USER.LOCATION' | translate }}</p>
    </button>
    @if (showRequestLocationButton()) {
      <button
        type="button"
        class="button-reset button-wrapper"
        tabindex="0"
        (click)="buttonClick.emit(footerButtonTypeEnum.MsgLocation)"
        (keydown)="onLocationRequestKeyDown($event)">
        <orbit-button
          [styleClass]="'addon-button'"
          rounded
          [icon]="locationRequestIcon"
          [testId]="'btn-user-location-request'" />
        <p>{{ 'SHARED.FOOTER_ADDON_USER.INQUIRY' | translate }}</p>
      </button>
    }
  }
</div>
